import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { AuthLayout } from "@/layouts/AuthLayout";
import { api } from "@/lib/api";

export function ResetPage() {
  const [params] = useSearchParams();
  const token = params.get("token") ?? "";
  const nav = useNavigate();
  const [pw1, setPw1] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<string | null>(null);
  const [ok, setOk] = useState(false);

  const inputStyle = { padding: 12, background: "var(--bg-elev-2)",
                       border: "1px solid var(--line)", borderRadius: 8, color: "var(--fg)" };

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (pw1 !== pw2) { setErr("Les deux mots de passe ne correspondent pas"); return; }
    if (!token) { setErr("Lien invalide"); return; }
    setBusy(true); setErr(null);
    try {
      await api("/api/account/password/reset/confirm", {
        method: "POST",
        body: JSON.stringify({ token, new_password: pw1 }),
      });
      setOk(true);
      setTimeout(() => nav("/login", { replace: true }), 2000);
    } catch (e2) {
      setErr(e2 instanceof Error ? e2.message : "Erreur");
    } finally { setBusy(false); }
  };

  return (
    <AuthLayout>
      <h1 style={{ marginTop: 0 }}>Nouveau mot de passe</h1>
      {ok ? (
        <div style={{ color: "#4ade80" }}>
          Mot de passe mis à jour. Redirection vers la connexion…
        </div>
      ) : (
        <form onSubmit={submit} className="stack" style={{ gap: 12 }}>
          <input type="password" placeholder="Nouveau mot de passe" value={pw1}
                 onChange={(e) => setPw1(e.target.value)} required minLength={8}
                 autoComplete="new-password" style={inputStyle} />
          <input type="password" placeholder="Confirmer" value={pw2}
                 onChange={(e) => setPw2(e.target.value)} required minLength={8}
                 autoComplete="new-password" style={inputStyle} />
          {err && <div style={{ color: "#f87171" }}>{err}</div>}
          <button className="btn primary" type="submit" disabled={busy || !pw1 || pw1 !== pw2}>
            {busy ? "…" : "Enregistrer"}
          </button>
          <div className="muted"><Link to="/login">Retour à la connexion</Link></div>
        </form>
      )}
    </AuthLayout>
  );
}
